import React, { useState, useEffect } from "react";
import "./AdminAllUserVisualisation.css";
import AggregatedUserCharts from "./AggregatedUserCharts/AggregatedUserCharts";

const AdminAllUserVisualisation = ({ allUserData }) => {
  // Flatten all scores from all users on load
  const getAllScores = (users) =>
    users.flatMap((user) =>
      user.scores.map((score) => ({
        ...score,
        username: user.username,
        role_title: user.role_title,
      }))
    );

  const [selectedOption, setSelectedOption] = useState("");
  const [filteredUserData, setFilteredUserData] = useState(
    getAllScores(allUserData)
  );
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  var roles = ["all"];
  if (allUserData && allUserData.length > 0) {
    for (let i = 0; i < allUserData.length; i++) {
      const user = allUserData[i];
      if (user.role_title && !roles.includes(user.role_title)) {
        roles.push(user.role_title);
      }
    }
  }

  const getMinMaxDates = (scores) => {
    const dates = scores
      .map((item) => {
        if (item.date && typeof item.date === "object" && item.date.$date) {
          return new Date(item.date.$date);
        }
        if (item.date) {
          return new Date(item.date);
        }
        return null;
      })
      .filter((date) => date && !isNaN(date.getTime()));
    if (dates.length === 0) return { min: "", max: "" };
    const minDateObj = new Date(Math.min(...dates));
    const maxDateObj = new Date(Math.max(...dates));
    const formatLocalDate = (date) =>
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0");
    return {
      min: formatLocalDate(minDateObj),
      max: formatLocalDate(maxDateObj),
    };
  };

  useEffect(() => {
    const { min, max } = getMinMaxDates(filteredUserData);
    setMinDate(min);
    setMaxDate(max);
    // Optionally reset date filters if out of new range
    setStartDate("");
    setEndDate("");
  }, [filteredUserData]);

  const handleChange = (event) => {
    const roleOption = event.target.value;
    setSelectedOption(roleOption);

    let newScores;
    if (roleOption === "all") {
      newScores = getAllScores(allUserData);
    } else {
      newScores = getAllScores(
        allUserData.filter((user) => user.role_title === roleOption)
      );
    }
    setFilteredUserData(newScores);
    // min/max dates will be set by useEffect above
  };

  return allUserData && allUserData.length > 0 ? (
    <div className="admin-visualisation">
      <h2>All User Visualisation</h2>

      <h3>Role filter</h3>
      <select value={selectedOption} onChange={handleChange}>
        <option value="" disabled>
          Select a role
        </option>
        {roles.map((role, index) => (
          <option key={index} value={role}>
            {role}
          </option>
        ))}
      </select>

      <AggregatedUserCharts
        allScores={filteredUserData}
        startDate={startDate}
        endDate={endDate}
        selectedOption={selectedOption}
      />

      <h3>Date Range Filter</h3>
      <div>
        <label>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            min={minDate || undefined}
            max={
              endDate
                ? endDate < maxDate
                  ? endDate
                  : maxDate
                : maxDate || undefined
            }
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            min={
              startDate
                ? startDate > minDate
                  ? startDate
                  : minDate
                : minDate || undefined
            }
            max={maxDate || undefined}
          />
        </label>
      </div>
    </div>
  ) : null;
};

export default AdminAllUserVisualisation;
